import { Component } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-marking-warn',
  templateUrl: './marking-warn.component.html',
  styleUrls: ['./marking-warn.component.scss'],
  standalone: false,
})
export class MarkingWarnComponent extends DialogContentBase {
  // dontShowAgain: boolean = false;
  action: 'markAbove' | 'markAll';
  constructor(dialog: DialogRef) {
    super(dialog);
  }

  confirmMarking() : void{
    this.dialog.close('yes');
  }
}
